import throttle from 'lodash.throttle';
import { CustomOnResize, CustomOnResizeEnd, CustomOnResizeStart } from 'modules/Editor/components/BoundingBox';
import { useCallback } from 'react';

type UseResponsiveWordCloudProps = {
  setResizeSize: (size: { width: number; height: number; isResizing: boolean }) => void;
};

export const useResponsiveWordCloud = ({ setResizeSize }: UseResponsiveWordCloudProps) => {
  // throttle update the size of the wordcloud while resizing to make it slightly less laggy
  const debounceUpdateSize = throttle((resize) => setResizeSize(resize), 100);

  const customOnResizeStart = useCallback(({ onResizeStart, event }: CustomOnResizeStart) => {
    onResizeStart(event);
    const target = event.target as HTMLElement;
    const width = target.clientWidth;
    const height = target.clientHeight;

    setResizeSize({ width, height, isResizing: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customOnResize = useCallback(
    ({ onResize, event }: CustomOnResize) => {
      onResize(event);
      const target = event.target as HTMLElement;
      const width = target.clientWidth || event.width;
      const height = target.clientHeight || event.height;
      debounceUpdateSize({ width, height, isResizing: true });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const customOnResizeEnd = useCallback(({ onResizeEnd, event }: CustomOnResizeEnd) => {
    onResizeEnd(event);
    const target = event.target as HTMLElement;
    const width = target.clientWidth;
    const height = target.clientHeight;
    debounceUpdateSize({ width, height, isResizing: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { customOnResize, customOnResizeStart, customOnResizeEnd };
};
